/* @flow */
import AdminSisSyncConnectedView from './AdminSisSyncConnectedView.jsx';

export default AdminSisSyncConnectedView;
